//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
  },
  name: 'imageSynthesis',
  data() {
    return {
    }
  },
  methods: {
    download() {
      this.$refs.imageSynthesis.getRes(true, this.getImage);
    },
    getImage(blob, base64) {
      console.log(blob)
      console.log(base64)
    }
  },
  watch: {
  },
  computed: {
  },
  created() {
  },
  mounted() {
  }
};
